// 取引先サブシステム。顧客 / 仕入先は同じ取引先テーブルの 2 つの顔（役割フラグ）。
const meta = (menu) => ({ requiresAuth: true, requiresBizhub: true, ...(menu ? { menu } : {}) });
export default [
  { path: "customers", name: "BizhubCustomers", component: () => import("@/views/Bizhub/PartyRoleListView.vue"), props: { role: "customer" },
    meta: meta({ group: "取引先", title: "顧客", order: 10 }) },
  { path: "suppliers", name: "BizhubSuppliers", component: () => import("@/views/Bizhub/PartyRoleListView.vue"), props: { role: "supplier" },
    meta: meta({ group: "取引先", title: "仕入先", order: 20 }) },
  { path: "contractors", name: "BizhubContractors", component: () => import("@/views/Bizhub/PartyRoleListView.vue"), props: { role: "contractor" },
    meta: meta({ group: "取引先", title: "外注先", order: 30 }) },
  { path: "parties/:id", name: "BizhubPartyDetail", component: () => import("@/views/Bizhub/PartyDetailView.vue"), meta: meta() },
  // 旧 URL とアシスタントの open_screen(parties) 用
  { path: "parties", name: "BizhubParties", redirect: { name: "BizhubCustomers" }, meta: meta() },
];
